import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { IonModal, IonicModule } from '@ionic/angular';
//import * as WebChat from 'botframework-webchat';
import { AIDirectLineTokenService } from 'src/app/services/ai-direct-line-token.service';
import { environment } from 'src/environments/environment';
import { UserInfoService } from 'src/app/services/user-info.service';
import { AzureChatBot } from 'src/app/models/viewmodels';
import { AppUser, Company, ProductModel, ProductType, Project } from 'src/app/models/dbmodels';
import { ActivatedRoute } from '@angular/router';

declare var WebChat: any;

declare global {
  interface Window {
    WebChat: any;
    webpage_id?: string;
    user_name?: string;
    webpage_version?: string;
  }
}

@Component({
  standalone: true,
  selector: 'ai-chatbot',
  templateUrl: './ai-chatbot.component.html',
  styleUrls: ['./ai-chatbot.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule
  ]

})
export class AIChatbotComponent  implements OnInit, AfterViewInit, OnChanges {

  // [webpage_id]="webpage_id"
  // [user_name]="user_name"
  // [webpage_version]="webpage_version"
  @Input() webpage_id: string;
  @Input() project: Project;
  @Input() PerfDataJson: string;
  @Input() projectCompany: Company;
  @Input() ProductType: ProductType;
  @Input() ProductModel: ProductModel;

  appUser: AppUser;

  aiFlowUrl: string = '';
  //userEmail: string = 'defaultEmail@default.com';
  conversationId: string = 'defaultConversationId';
  contactRSMName: string = '';
  contactRSMEmail: string = '';

  chatBotInit: AzureChatBot;


  constructor(private elementRef: ElementRef, private aiTokenService: AIDirectLineTokenService, private userInfoService: UserInfoService, private route: ActivatedRoute) { 
    this.appUser = this.userInfoService.getAppUser();
  }

  ngOnInit() {

    this.contactRSMEmail = this.projectCompany?.Region?.RegionalSalesManager?.EmailAddress ?? '';
    this.contactRSMName = this.projectCompany?.Region?.RegionalSalesManager?.DisplayName ?? '';

    this.aiFlowUrl = environment.aiFlowUrl;
    //this.loadWebChat();
    this.route.params.subscribe(params => {
      console.log('ai route params:', params, params['projectId']);
      //console.log('item-performance.ngoninit - params, subscription', params);
      // this.projectScheduleLineItemId = params['projectScheduleLineItemId'];
      // this.projectScheduleId = params['projectScheduleId'] as number;
      // this.projectId = params['projectId'];
    });

  }

  ngAfterViewInit() {
    this.launchWebChat();
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('ai-chatbot ngOnChanges changes', changes);
  }

  async loadWebChat(): Promise<void> {
  //   const token = await this.aiTokenService.getToken();
  //   console.log('AI Flow Token:', token);
  //   const directLine = WebChat.createDirectLine({
  //     token
  //   });
  //   console.log('Direct Line Object:', directLine);
  //   WebChat.renderWebChat(
  //     { directLine },
  //     this.elementRef.nativeElement.querySelector('#webchat')
  //   );
  }

  async launchWebChat(): Promise<void> {
    const self = this;

    this.contactRSMEmail = this.projectCompany?.Region?.RegionalSalesManager?.EmailAddress ?? '';
    this.contactRSMName = this.projectCompany?.Region?.RegionalSalesManager?.DisplayName ?? '';

    //create a conversation id
    const conversationId = 'conv_' + Math.random().toString(36).substr(2, 9);

    this.chatBotInit = {
      ConversationId: conversationId,
      UserName: this.appUser?.FirstName + ' ' + this.appUser?.LastName,
      UserEmail: this.appUser?.EmailAddress,
      CompanyId: this.appUser?.DefaultCompanyId?.toString(),
      ProjectId: this.project?.ProjectId?.toString(),
      PerfDataJson: this.PerfDataJson,
      ContactRSMName: this.contactRSMName ?? '',
      ContactRSMEmail: this.contactRSMEmail ?? '', 
      ProductTypeName: this.ProductType?.Name ?? '',
      ProductModelName: this.ProductModel?.Name ?? '',
    };

  (() => {  
    
    console.log('test test');
    // Load the WebChat library programmatically.
    // This guarantees window.WebChat exists before we use it.

    function loadWebChatLibrary(callback) {
      if (window.WebChat) { callback(); return; } // already loaded
      var s = document.createElement('script');
      //s.src = 'https://cdn.botframework.com/botframework-webchat/4.11.0/webchat+bundle.js';
      // cns:  must manually copy what is in node modules to the assets/webchat folder
      s.src = '/assets/webchat/webchat.js'
      s.onload = callback;
      s.onerror = function () { console.error('[chat-widget] Failed to load WebChat library.'); };
      document.head.appendChild(s);
    }

    // Safety net: suppress a known WebChat "conversation ended" bug.
    window.addEventListener('error', function (event) {
      if (event && event.message && event.message.indexOf('conversation ended') !== -1) {
        console.warn('[chat-widget] Suppressed known WebChat "conversation ended" bug. Safe to ignore.');
        event.preventDefault();
      }
    });

    // Grab the HTML elements we react to.
    const launcher   = document.getElementById('cs-launcher');
    const chatWindow = document.getElementById('cs-chat-window');
    const closeBtn   = document.getElementById('cs-chat-close');
    const restartBtn = document.getElementById('cs-chat-restart');

    // Simple state memory.
    let webChatInitialized = false;
    let directLine = null;
    let webChatStore = null;
    let lastActivityTimestamp = null;

    // How long before an idle chat is reset (10 minutes).
    const INACTIVITY_LIMIT_MS = 10 * 60 * 1000;

    // Your Power Automate flow URL that returns a Direct Line token.
    const FLOW_URL = self.aiFlowUrl;// 

    // =================================================================
    // [ CONTEXT EDIT 1 ]  Auto-capture 3 values from the webpage.
    // =================================================================
    // The user is NEVER prompted for these. They are read automatically
    // the moment the widget loads, from any of three sources (in order):
    //   1) URL query string, e.g. yourpage.com?webpage_id=123&user_name=Carl&webpage_version=2.1
    //   2) Global JS variables your site may set, e.g. window.webpage_id = "123";
    //   3) A safe fallback default if neither is present.
    // Adjust these sources to match how YOUR website supplies the values.
    const _params = new URLSearchParams(window.location.search);

    //cns: replacing with ChatBotInit
    // const CONTEXT_VARS = {
    //   webpage_id:    'unknown',
    //   user_name:     'guest',
    //   webpage_version: 'Website v1.0'
    // };
    // console.log('[chat-widget] Context variables captured:', CONTEXT_VARS);
    
    // Log them once so you can confirm they were captured (visible in F12 console).
    // =================================================================

    // Custom store: tracks the last activity time (used for inactivity reset).
    function createActivityTrackingStore() {
      return window.WebChat.createStore(
        {},
        () => next => action => {
          if (
            action.type === 'DIRECT_LINE/POST_ACTIVITY' ||
            action.type === 'DIRECT_LINE/INCOMING_ACTIVITY'
          ) {
               lastActivityTimestamp = Date.now();
          }
          
          //cns: adding performance data to current text prompt submit
          //if (action.type === 'WEB_CHAT/SUBMIT_SEND_BOX') {  
          if (action.type === 'WEB_CHAT/SEND_MESSAGE') {  
            const originalActivity = action.payload.activity;
            const originalPayload = action.payload;

            let perfJson = document.getElementById('div-perf-data')?.getAttribute('data-perf-data-json');

            if (perfJson) {
              action.payload = {
                  ...originalPayload, 
                  channelData: {
                    ...originalPayload.channelData,
                    PerfDataJson: perfJson,
                    ProductModelName: self.ProductModel?.Name ?? '',
                    ProductTypeName: self.ProductType?.Name ?? ''
                  }
                }
            }
          }

          if (action.type === 'WEB_CHAT/SET_SEND_BOX_MODE') {
            return next(action);  // do NOT override
          }

          return next(action);
        }
      );
    }


    // Deliberate reset: disconnect old store, rebuild the #webchat div, reset trackers.
    function resetChatSession() {
      console.log('[chat-widget] resetting chat session at ' + new Date().toISOString());
      //console.log('[chat-widget] conversationId before reset:', this.conversationId);

      if (webChatStore) {
        try { webChatStore.dispatch({ type: 'DIRECT_LINE/DISCONNECT' }); }
        catch (err) { console.warn('[chat-widget] Store disconnect failed:', err); }
        webChatStore = null;
      }

      const oldWebchat = document.getElementById('webchat');
      if (oldWebchat) {
        const newWebchat = document.createElement('div');
        newWebchat.id = 'webchat';
        newWebchat.setAttribute('role', 'main');
        oldWebchat.parentNode.replaceChild(newWebchat, oldWebchat);
      }

      webChatInitialized = false;
      directLine = null;
      lastActivityTimestamp = null;
      launcher.classList.remove('cs-has-unread');
    }

    // Fetch a token from your flow, connect to the agent, and render the chat.
    async function initWebChat() {

      // CONTEXT_VARS.user_name = 'guest';
      // CONTEXT_VARS.webpage_id = 'unknown';
      // CONTEXT_VARS.webpage_version = 'Website v1.0';

      if (webChatInitialized) {
         return;
      }
 
      try {
        // Ask your Power Automate flow for a Direct Line token.
        const res = await fetch(FLOW_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: '{}'
        });

        if (!res.ok) {
          const webchatDiv = document.getElementById('webchat');
          if (webchatDiv) webchatDiv.innerText = 'Chat unavailable. Please try again later.';
          return;
        }

        const data = await res.json();

        // Create the live Direct Line connection using the token.
        directLine = window.WebChat.createDirectLine({ token: data.token });
        //this.directLineChat = directLine;

        console.log('chatbot - ', self.chatBotInit);

        // When the connection is Online (status 2), fire the greeting AND
        // send our 3 context variables to the agent.
        directLine.connectionStatus$.subscribe(function (status) 
        {
            //status = 5 is the end of conversation value
            // if (status === 5) {
            //   console.warn('[chat-widget] Suppressing Ended status');
            //   return;
            // }

            if (status === 2) { // Online

              // =========================================================
              // [ CONTEXT EDIT 2 ]  Send the 3 variables to Copilot Studio.
              // =========================================================
              // We reuse the startConversation event (which also triggers
              // your Greeting topic) and attach CONTEXT_VARS in "value".
              // In Copilot Studio these arrive as:
              //   System.Activity.Value.webpage_id
              //   System.Activity.Value.user_name
              //   System.Activity.Value.webpage_version
              directLine.postActivity({
                type: 'event',
                name: 'startConversation',
                value: self.chatBotInit,                     // <-- the 3 variables travel here
                from: { UserEmail: self.appUser.EmailAddress }
              }).subscribe();
              // =========================================================
            }

            if (status === 5) { // Ended (diagnostic only)
              console.warn('[chat-widget] Connection reports "Ended." Diagnostic only.');
              //return;
            }
        });

        // Watch every activity BEFORE render: strip citation tags + light the unread dot.
        directLine.activity$.subscribe(function (activity) {
          console.log('activity:', activity);
          if (
            activity.type === 'message' &&
            activity.from && activity.from.role === 'bot' &&
            activity.text
          ) {
            activity.text = activity.text
              .replace(/\[\d+\]|\[doc\d+\]/g, '')                    // [1], [doc1]
              .replace(/\s*:?\s*cite:\d+\s*["“][\s\S]*?["”]/gi, '')   // cite:1 "Citation-1"
              .replace(/\s{2,}/g, ' ')                                // collapse double spaces
              .trim();
          }
          if (
            activity.from && activity.from.role === 'bot' &&
            !chatWindow.classList.contains('cs-open')
          ) {
            launcher.classList.add('cs-has-unread');
          }
        });

        // Build the store and keep a reference so reset can disconnect it.
        webChatStore = createActivityTrackingStore();

        // Draw the chat UI into #webchat.
        window.WebChat.renderWebChat(
          {
            directLine: directLine,
            store: webChatStore,
            styleOptions: {
              backgroundColor: '#FFFFFF',
              bubbleBackground: '#F2F2F2',
              bubbleFromUserBackground: '#0078D4',
              bubbleFromUserTextColor: '#FFFFFF',
              sendBoxBackground: '#FAFAFA',
              rootHeight: '100%',
              rootWidth: '100%',
              hideUploadButton: true,
              //cns:multi-line only supported in react apps
              //cns:make multi-line
              // sendBox: {
              //   multiline: true,
              //   autoExpand: true   // optional
              // }
            }
          },
          document.getElementById('webchat')
        );

        lastActivityTimestamp = Date.now();

        //init must all set web chat as initialized as true
        webChatInitialized = true;

      } catch (err) {
        const webchatDiv = document.getElementById('webchat');
        if (webchatDiv) webchatDiv.innerText = 'Chat failed to load.';
        console.error('WebChat error:', err);
      }
    }

    // Launcher click: check inactivity, then open + init the chat.
    launcher.addEventListener('click', async function () {
      if (
        webChatInitialized &&
        lastActivityTimestamp &&
        (Date.now() - lastActivityTimestamp > INACTIVITY_LIMIT_MS)
      ) {
        console.log('[chat-widget] session inactive too long — starting fresh');
        resetChatSession();
      }

      chatWindow.classList.add('cs-open');
      chatWindow.style.visibility = 'visible';
      launcher.classList.remove('cs-has-unread');

      loadWebChatLibrary(() => initWebChat());
    });

    // Close button: hide the window only (does NOT reset the session).
    closeBtn.addEventListener('click', function () {
      chatWindow.classList.remove('cs-open');
      chatWindow.style.visibility = 'hidden';
    });

    // Restart button: the one deliberate reset path.
    restartBtn.addEventListener('click', async function () {
      resetChatSession();

      chatWindow.classList.add('cs-open');        // popup becomes visible
      chatWindow.style.visibility = 'visible';    // ensure layout exists
      
      setTimeout(() => {
        initWebChat();
      }, 300);
      
    });

  })();

  }

}
